import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ApproveForm from "../ApproveForm/ApproveForm";
import {
  Grid,
  Accordion,
  AccordionSummary,
  Typography,
  CircularProgress,
  AccordionDetails,
} from "@mui/material";

import withStyles from '@mui/styles/withStyles';

import eventIcon from "../../img/dropdown-icons/EventDetails.svg";
import EventDetails from "../EventDetails/EventDetails";
import contractIcon from "../../img/dropdown-icons/Contract.svg";
import ContactDetails from '../ContactDetails/ContactDetails';
import { useHttp, httpGet } from '../../hooks/http';
import { UserContext } from '../../UserContext';

const styles = {
  padding: {
    padding: 10,
    marginTop: 10
  },
  heading: {
    fontWeight: "bold"
  },
  centerSpiner: {
    margin: "auto",
    textAlign: "center"
  },
  margin: {
    marginTop: 20
  },
  icon: {
    marginRight: 10
  },
  paddingInside: {
    padding: 13
  }
};

const ApproveEvent = props => {
  const { access_token } = useContext(UserContext);
  const { classes, location } = props;
  const [eventState, setEventState] = useState([]);
  const [ expanded, setExpanded ] = useState(false);

  const [ loaded, fetchedData ] = useHttp(`clientPortal/events/${props.match.params.id }/components/contract`, access_token, []);
  
  const fetchEventInfo = () => {
    setExpanded(!expanded);
    if(!expanded && eventState.length === 0)
      httpGet(`clientPortal/events/${ props.match.params.id }/components/eventInfo`, access_token).then(result => setEventState(result.response));
  };

  return (
    <Grid container className={classes.padding}>
      <Grid item xs={12}>
        <Accordion onChange={()=>{fetchEventInfo(expanded)}} className={classes.margin}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <img src={eventIcon} alt={eventIcon} className={classes.icon} />
            <Typography className={classes.heading}>Event Details</Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.paddingInside}>
            {loaded 
              ? <EventDetails pastEvent={true} eventState={eventState} />
              : <CircularProgress className={classes.centerSpiner} /> }
          </AccordionDetails>
        </Accordion>
        <Accordion defaultExpanded={true} className={classes.margin}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <img src={contractIcon} alt={contractIcon} className={classes.icon} />
            <Typography className={classes.heading}>Contract Details</Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.paddingInside}>
            {loaded ? <ContactDetails  contactInfo={fetchedData.contract} />
            : <CircularProgress className={classes.centerSpiner} />
            }
          </AccordionDetails>
        </Accordion>
      </Grid>
      <Grid item xs={12} className={classes.margin}>
        {loaded ?  <ApproveForm
          eventId={props.match.params.id}
          guests={location.state.event.guestCount}
          eventClientPortal={location.state.eventClientPortal}
        /> 
        : null }
       
      </Grid>
    </Grid>
  );
};

ApproveEvent.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ApproveEvent);
